import React, { useState, useRef } from "react";
import ControldocFormTemplateLayoutForm from "../../../controldoc_form/template_layout/form";
import {
  create as createTemplateLayout,
  update as updateTemplateLayout,
  preview as previewTemplateLayout
} from "./axios";

const CorporateControldocFormTemplateLayoutForm = props => {
  return(
    <ControldocFormTemplateLayoutForm
      templateLayout={ props?.templateLayout || {} }
      imagePicker={ props?.imagePicker }
      configuration={{
        formName: 'corporate_controldoc_form_template_layout',
        context: 'corporate'
      }}
      actions={{
        createTemplateLayout: createTemplateLayout,
        updateTemplateLayout: updateTemplateLayout,
        previewTemplateLayout: previewTemplateLayout,
        showTemplateLayoutPath: Routes.corporate_controldoc_form_template_layout_path,
        indexTemplateLayoutPath: Routes.corporate_controldoc_form_template_layouts_path
      }}
    />
  )
}

export default CorporateControldocFormTemplateLayoutForm;
